module.exports = __webpack_public_path__ + "img/man.00d8cfe8.svg";